export default __webpack_public_path__ + "static/media/Mark-2-Suit-07.5ff91992.jpg";